import React, { useEffect, useState } from "react";
import InputField from "components/fields/InputField";
import { Controller, useWatch } from "react-hook-form";
import Select from "react-tailwindcss-select";
import getSelectClassNames from "components/SelectFieldClasses/SelectFieldClasses";
import { toast } from "react-toastify";
import CustomerDetails from "./CustomerDetails";
import userResources from "api/userResources";
import Calculation from "./Calculation";
import FindInteneryDetails from "./FindInteneryDetails";

const gdsLocator = [
  {
    value: "sabre",
    label: "Sabre",
  },
  {
    value: "amadeus",
    label: "Amadeus",
  },
];

const ticketStatus = [
  {
    value: "Issue",
    label: "Issue",
  },
  {
    value: "Reissue",
    label: "Reissue",
  },
  {
    value: "Refund",
    label: "Refund",
  },
  {
    value: "Void",
    label: "Void",
  },
  {
    value: "Parial refund",
    label: "Parial refund",
  },
  {
    value: "Pending ticket",
    label: "Pending ticket",
  },
  {
    value: "Ticket itinerary",
    label: "Ticket itinerary",
  },
  {
    value: "All inclusive package",
    label: "All inclusive package",
  },
  {
    value: "Group ticket (Non refundable & Non changeable).",
    label: "Group ticket (Non refundable & Non changeable).",
  },
];

const AirTicket = ({
  register,
  errors,
  setError,
  airTicket,
  passengerFields,
  appendPassenger,
  removePassenger,
  flightFields,
  appendFlight,
  removeFlight,
  control,
  clearErrors,
  watch,
  setValue,
  getValues,
  reset,
  AirTickettoSupplier,
  AirTicketfromPax,
  updateData,
  appendinsurance,
  removeinsurance,
  insuranceFields,
  setInsurance,
}) => {
  const [supplierData, setSupplierData] = useState([]);

  const getSuppliers = async () => {
    try {
      const response = await userResources.supplier();
      const combinedData = response.data.data.map((item) => ({
        value: item.id,
        label: item.name,
      }));

      setSupplierData(combinedData);
      setUpdateData();
    } catch (error) {
      console.log(error);
    }
  };

  const setUpdateData = () => {
    if (updateData) {
      const toBoolean = (value) => String(value).toLowerCase() === "true";

      // Using prefixPax for the key and when accessing updateData
      // AIRTICKET
      setValue(
        `airticket.passengers.adt`,
        Number(updateData?.airticket?.passengers?.adt)
      );
      setValue(
        `airticket.passengers.chd`,
        Number(updateData?.airticket?.passengers?.chd)
      );
      setValue(
        `airticket.passengers.inf`,
        Number(updateData?.airticket?.passengers?.inf)
      );
      setValue(
        `airticket.airticket_from_pax.baseFare.adt1`,
        Number(updateData?.airticket?.airticket_from_pax?.baseFare?.adt1)
      );
      setValue(
        `airticket.airticket_from_pax.baseFare.chd1`,
        Number(updateData?.airticket?.airticket_from_pax?.baseFare?.chd1)
      );
      setValue(
        `airticket.airticket_from_pax.baseFare.inf1`,
        Number(updateData?.airticket?.airticket_from_pax?.baseFare?.inf1)
      );
      setValue(
        `airticket.airticket_from_pax.gstHst.adt1`,
        Number(updateData?.airticket?.airticket_from_pax?.gstHst?.adt1)
      );
      setValue(
        `airticket.airticket_from_pax.gstHst.chd1`,
        Number(updateData?.airticket?.airticket_from_pax?.gstHst?.chd1)
      );
      setValue(
        `airticket.airticket_from_pax.gstHst.inf1`,
        Number(updateData?.airticket?.airticket_from_pax?.gstHst?.inf1)
      );
      setValue(
        `airticket.airticket_from_pax.taxes.adt1`,
        Number(updateData?.airticket?.airticket_from_pax?.taxes?.adt1)
      );
      setValue(
        `airticket.airticket_from_pax.taxes.chd1`,
        Number(updateData?.airticket?.airticket_from_pax?.taxes?.chd1)
      );
      setValue(
        `airticket.airticket_from_pax.taxes.inf1`,
        Number(updateData?.airticket?.airticket_from_pax?.taxes?.inf1)
      );
      setValue(
        `airticket.airticket_from_pax.amountPaid`,
        Number(updateData?.airticket?.airticket_from_pax?.amountPaid)
      );
      setValue(
        `airticket.airticket_from_pax.refund`,
        Number(updateData?.airticket?.airticket_from_pax?.refund)
      );
      setValue(
        `airticket.airticket_from_pax.refund_paid`,
        Number(updateData?.airticket?.airticket_from_pax?.refund_paid)
      );
      setValue(
        `airticket.airticket_from_pax.payment_received_from_pax`,
        toBoolean(
          updateData?.airticket?.airticket_from_pax?.payment_received_from_pax
        )
      );

      // Using supplierPax for the key and when accessing updateData
      setValue(
        `airticket.airticket_to_supplier.baseFare.adt1`,
        Number(updateData?.airticket?.airticket_to_supplier?.baseFare?.adt1)
      );
      setValue(
        `airticket.airticket_to_supplier.baseFare.chd1`,
        Number(updateData?.airticket?.airticket_to_supplier?.baseFare?.chd1)
      );
      setValue(
        `airticket.airticket_to_supplier.baseFare.inf1`,
        Number(updateData?.airticket?.airticket_to_supplier?.baseFare?.inf1)
      );
      setValue(
        `airticket.airticket_to_supplier.gstHst.adt1`,
        Number(updateData?.airticket?.airticket_to_supplier?.gstHst?.adt1)
      );
      setValue(
        `airticket.airticket_to_supplier.gstHst.chd1`,
        Number(updateData?.airticket?.airticket_to_supplier?.gstHst?.chd1)
      );
      setValue(
        `airticket.airticket_to_supplier.gstHst.inf1`,
        Number(updateData?.airticket?.airticket_to_supplier?.gstHst?.inf1)
      );

      setValue(
        `airticket.airticket_to_supplier.paymentMade`,
        Number(updateData?.airticket?.airticket_to_supplier?.paymentMade)
      );
      setValue(
        `airticket.airticket_to_supplier.refund`,
        Number(updateData?.airticket?.airticket_to_supplier?.refund)
      );
      setValue(
        `airticket.airticket_to_supplier.payment_received_from_supplier`,
        Number(
          updateData?.airticket?.airticket_to_supplier
            ?.payment_received_from_supplier
        )
      );
      setValue(
        `airticket.airticket_to_supplier.recall_commission_to_supplier`,
        Number(
          updateData?.airticket?.airticket_to_supplier
            ?.recall_commission_to_supplier
        )
      );
      setValue(
        `airticket.airticket_to_supplier.cash_in_hand`,
        Number(updateData?.airticket?.airticket_to_supplier?.cash_in_hand)
      );
      setValue(
        `airticket.airticket_to_supplier.commission_from_supplier`,
        toBoolean(
          updateData?.airticket?.airticket_to_supplier?.commission_from_supplier
        )
      );
      setValue(
        `airticket.airticket_to_supplier.refund_received_from_supplier`,
        toBoolean(
          updateData?.airticket?.airticket_to_supplier
            ?.refund_received_from_supplier
        )
      );
    }
  };

  const handleUploadItinerary = (value) => {
    if (!value) {
      toast.warning("Kindly paste your itinerary...");
      return;
    }

    const itineraryText = value;

    const { passengers, flights } = FindInteneryDetails(itineraryText);

    // Update keys to match nested defaultValues
    if (passengers?.length > 0) {
      setValue("airticket.passenger_details", passengers);
      clearErrors("airticket.passenger_details");
    }

    if (flights?.length > 0) {
      setValue("airticket.flight_details", flights);
      clearErrors("airticket.flight_details");
    }
  };

  const handleClearItinerary = () => {
    // Reset to nested default values structure
    reset({
      itinerary: "",
      gdsLocator: "",
      airticket: {
        passenger_details: [
          {
            first_name: "",
            last_name: "",
            bill_to: false,
            add_insurance: false,
          },
        ],
        flight_details: [
          {
            airline: "",
            from: "",
            to: "",
            date: "",
            flight_no: "",
            dep_time: "",
            arr_time: "",
          },
        ],
        airticket_from_pax: {
          baseFare: { adt1: null, chd1: null, inf1: null },
          gstHst: { adt1: null, chd1: null, inf1: null },
          taxes: { adt1: null, chd1: null, inf1: null },
          subTotal: { adt1: 0, chd1: 0, inf1: 0 },
          total: 0,
          amountPaid: 0,
          transation_type_id: null,
          commission: null,
          payment_received_from_pax: false,
        },
        airticket_to_supplier: {
          baseFare: { adt1: null, chd1: null, inf1: null },
          gstHst: { adt1: null, chd1: null, inf1: null },
          taxes: { adt1: null, chd1: null, inf1: null },
          subTotal: { adt1: 0, chd1: 0, inf1: 0 },
          total: 0,
          paymentMade: false,
          transation_type_id: "",
          paymeny_received_from_supplier: false,
        },
      },
    });
    // watch("itinerary", "");
    clearErrors();
  };
  const handleBillToChange = (selectedIndex) => {
    // Get the current value of the selected radio button.
    const currentValue =
      watch(`airticket.passenger_details[${selectedIndex}].bill_to`) || false;

    // Toggle the selected radio button:
    // If it was true, it becomes false; if false, it becomes true.
    passengerFields.forEach((item, index) => {
      setValue(
        `airticket.passenger_details[${index}].bill_to`,
        index === selectedIndex ? !currentValue : false
      );
    });
  };

  const handleInsuranceCheckbox = (index, event) => {
    const isChecked = event.target.checked;

    setValue(`airticket.passenger_details[${index}].add_insurance`, isChecked);

    const passenger = getValues(`airticket.passenger_details[${index}]`);

    if (isChecked) {
      // ✅ Append to the end
      appendinsurance({
        first_name: passenger.first_name || "",
        last_name: passenger.last_name || "",
        passengerIndex: index,
      });
    } else {
      // ❌ Only remove if match is found
      const removeIndex = insuranceFields.findIndex(
        (item) =>
          item.first_name === passenger.first_name &&
          item.last_name === passenger.last_name
      );

      if (removeIndex !== -1) {
        removeinsurance(removeIndex);
      }
    }
  };

  useEffect(() => {
    getSuppliers();
  }, []);

  return (
    <section className="px-2">
      <div className="">
        <h2 className="text-lg font-semibold text-[#09c8ff]">
          Air Ticket Details
        </h2>

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-3 md:grid-cols-5">
          <InputField
            label="Ticket Number"
            id="ticket_number"
            type="text"
            placeholder="Enter Ticket Number"
            register={register}
            name="ticket_number"
            rules={{ required: "Ticket Number is required" }}
            errorMessage={errors.ticket_number?.message}
            onChange={() => clearErrors("ticket_number")}
            bgAllDark={true}
          />
          <InputField
            label="MCO"
            id="mco"
            type="text"
            placeholder="Enter MCO"
            register={register}
            name="mco"
            bgAllDark={true}
          />
          <InputField
            label="Ref No ET"
            id="reference_no_et"
            name="reference_no_et"
            type="text"
            placeholder="Enter Reference Number"
            register={register}
            bgAllDark={true}
          />
          <div>
            <label className="my-2 block text-sm font-medium text-[#09c8ff]">
              Ticket status
            </label>
            <Controller
              name="status"
              control={control}
              defaultValue={""} // ← start empty
              rules={{ required: "Ticket status is required." }} // ← un‐commented!
              render={({ field, fieldState }) => (
                <>
                  <Select
                    {...field}
                    value={ticketStatus.find(
                      (opt) => opt.value === field.value
                    )}
                    onChange={(selectedOption) => {
                      field.onChange(selectedOption?.value);
                    }}
                    options={ticketStatus}
                    isSearchable
                    placeholder="Select..."
                    classNames={getSelectClassNames({
                      isDisabled: false,
                      selectProps: {},
                      isSelected: Boolean(field.value),
                      value: field.value,
                    })}
                    formatOptionLabel={(data) => (
                      <li
                        className={`mb-1 block cursor-pointer select-none truncate rounded px-2 py-2 transition duration-200 ${
                          data.value === field.value
                            ? `bg-blue-800 text-gray-200`
                            : `bg-gray-200 text-gray-900`
                        }`}
                      >
                        {data.label}
                      </li>
                    )}
                  />
                  {fieldState.error && (
                    <span className="text-sm text-red-500">
                      {fieldState.error.message}
                    </span>
                  )}
                </>
              )}
            />
          </div>
        </div>

        <p className="my-2 bg-[#09c8ff] px-2 text-xs text-white">
          Passenger Details: (Copy the GDS Itinerary & Paste into the text area
          shown below, click on Upload Itinerary button)
        </p>

        <div className="grid-col-1 grid gap-x-2 sm:grid-cols-2 md:grid-cols-5">
          <div className="">
            <label className="my-2 block text-sm font-medium text-[#09c8ff]">
              Please Choose the GDS
            </label>
            <Controller
              name="gds_type"
              control={control}
              defaultValue={watch("gds_type")}
              // rules={{ required: "Gds is required." }}
              render={({ field }) => (
                <Select
                  {...field}
                  value={gdsLocator.find(
                    (source) => source.value === field.value
                  )}
                  onChange={(selectedOption) => {
                    setValue("gds_type", selectedOption?.value || "");
                    clearErrors("gds_type");
                  }}
                  options={gdsLocator}
                  isSearchable={true}
                  placeholder="Select..."
                  classNames={getSelectClassNames({
                    isDisabled: false,
                    selectProps: {},
                    isSelected: false,
                    value: watch("gds_type"),
                  })}
                  formatOptionLabel={(data) => (
                    <li
                      className={`mb-1 block cursor-pointer select-none truncate rounded px-2 py-2 transition duration-200 ${
                        !data.isSelected
                          ? `bg-gray-200 text-gray-900`
                          : `bg-blue-800 text-gray-200`
                      }`}
                    >
                      {data.label}
                    </li>
                  )}
                />
              )}
            />
            {errors.gds_type && (
              <span className="text-sm text-red-500">
                {errors.gds_type.message}
              </span>
            )}
          </div>

          <div className="md:col-span-3">
            <textarea
              id="itinerary"
              name="itinerary"
              placeholder="Paste Your Itinerary here"
              className="bg-dark w-full rounded border border-gray-600 bg-white p-2 text-black focus:border-blue-500 focus:outline-none"
              rows={3}
              {...register("itinerary")}
            />
          </div>
          <div className="flex flex-col gap-2">
            <button
              type="button"
              className="rounded-md border-green-500 bg-white py-2 text-green-500 hover:bg-green-500 hover:text-white"
              onClick={() => handleUploadItinerary(watch("itinerary"))}
            >
              Upload Itinerary
            </button>

            <button
              type="button"
              className="rounded-md border-red-500 bg-white py-2 text-red-500 hover:bg-red-500 hover:text-white"
              onClick={handleClearItinerary}
            >
              Clear Itinerary
            </button>
          </div>
        </div>

        {/* Passenger Fields */}
        <div>
          {passengerFields.map((item, index) => (
            <div
              key={item.id}
              className="grid grid-cols-2 items-end gap-x-2 sm:grid-cols-3 md:grid-cols-6"
            >
              <InputField
                label="Last Name"
                id={`airticket.passenger_details[${index}].last_name`}
                type="text"
                placeholder="enter passanger last name"
                register={register}
                name={`airticket.passenger_details[${index}].last_name`}
                rules={{ required: "Last Name is required" }}
                errorMessage={
                  errors?.airticket?.passenger_details?.[index]?.last_name
                    ?.message
                }
                onChange={() =>
                  clearErrors(`airticket.passenger_details[${index}].last_name`)
                }
                bgAllDark={true}
              />
              <InputField
                label="First Name"
                id={`airticket.passenger_details[${index}].first_name`}
                type="text"
                placeholder="enter passanger first name"
                register={register}
                name={`airticket.passenger_details[${index}].first_name`}
                rules={{ required: "First Name is required" }}
                errorMessage={
                  errors?.airticket?.passenger_details?.[index]?.first_name
                    ?.message
                }
                onChange={() =>
                  clearErrors(
                    `airticket.passenger_details[${index}].first_name`
                  )
                }
                bgAllDark={true}
              />
              <InputField
                label="Title"
                id={`airticket.passenger_details[${index}].title`}
                type="text"
                placeholder="Mr, Mrs"
                register={register}
                name={`airticket.passenger_details[${index}].title`}
                // rules={{ required: "Title is required" }}
                // errorMessage={
                //   errors?.airticket?.passenger_details?.[index]?.title?.message
                // }
                // onChange={() =>
                //   clearErrors(`airticket.passenger_details[${index}].title`)
                // }
                bgAllDark={true}
              />
              <div className="flex h-full flex-col justify-between">
                <label className="relative top-2.5 text-sm text-[#09c8ff]">
                  Bill To
                </label>
                <input
                  type="radio"
                  name={`airticket.passenger_details[${index}].bill_to`}
                  checked={
                    watch(`airticket.passenger_details[${index}].bill_to`) ||
                    false
                  }
                  // Use onClick instead of onChange to catch clicks on an already selected radio
                  onClick={() => handleBillToChange(index)}
                  className="mt-6 w-10 sm:mt-0"
                />
              </div>
              <div className="flex h-full flex-col justify-between">
                <label className="relative top-2.5 text-sm text-[#09c8ff]">
                  Add Insurance
                </label>
                <input
                  type="checkbox"
                  {...register(
                    `airticket.passenger_details[${index}].add_insurance`
                  )}
                  onChange={(e) => {
                    // ✅ Let RHF handle the update
                    const originalHandler = register(
                      `airticket.passenger_details[${index}].add_insurance`
                    ).onChange;
                    originalHandler(e); // preserve RHF's update

                    // ✅ Your custom logic
                    handleInsuranceCheckbox(index, e);
                  }}
                  className="mt-6 w-10 sm:mt-0"
                />
              </div>
              {passengerFields.length > 1 && (
                <button
                  type="button"
                  onClick={() => {
                    const passenger = getValues(
                      `airticket.passenger_details[${index}]`
                    );

                    // Remove from insurance if exists
                    const insuranceIndex = insuranceFields.findIndex(
                      (item) =>
                        item.first_name === (passenger.first_name || "") &&
                        item.last_name === (passenger.last_name || "")
                    );

                    if (insuranceIndex !== -1) {
                      removeinsurance(insuranceIndex);
                    }

                    // Now remove the flight/passenger
                    removePassenger(index);
                  }}
                  className="rounded-md border-red-500 bg-white py-2 text-red-500 hover:bg-red-500 hover:text-white"
                >
                  Remove
                </button>
              )}
            </div>
          ))}
        </div>
        <button
          type="button"
          onClick={() =>
            appendPassenger({
              first_name: "",
              last_name: "",
              bill_to: false,
              add_insurance: false,
            })
          }
          className="mt-2 text-blue-600 hover:text-blue-800"
        >
          Add Passenger
        </button>

        {/* Flight Details */}
        {flightFields.map((item, index) => (
          <div
            key={item.id}
            className="grid grid-cols-2 items-end gap-x-2 sm:grid-cols-4 md:grid-cols-8"
          >
            <InputField
              label="Airline"
              id={`airticket.flight_details[${index}].airline`}
              type="text"
              placeholder="Enter Airline"
              register={register}
              name={`airticket.flight_details[${index}].airline`}
              rules={{ required: "Airline is required" }}
              errorMessage={
                errors?.airticket?.flight_details?.[index]?.airline?.message
              }
              onChange={() =>
                clearErrors(`airticket.flight_details[${index}].airline`)
              }
              bgAllDark={true}
            />
            <InputField
              label="From"
              id={`airticket.flight_details[${index}].from`}
              type="text"
              placeholder="Enter Departure City"
              register={register}
              name={`airticket.flight_details[${index}].from`}
              rules={{ required: "Departure city is required" }}
              errorMessage={
                errors?.airticket?.flight_details?.[index]?.from?.message
              }
              onChange={() =>
                clearErrors(`airticket.flight_details[${index}].from`)
              }
              bgAllDark={true}
            />
            <InputField
              label="To"
              id={`airticket.flight_details[${index}].to`}
              type="text"
              placeholder="Enter Destination City"
              register={register}
              name={`airticket.flight_details[${index}].to`}
              rules={{ required: "Destination city is required" }}
              errorMessage={
                errors?.airticket?.flight_details?.[index]?.to?.message
              }
              onChange={() =>
                clearErrors(`airticket.flight_details[${index}].to`)
              }
              bgAllDark={true}
            />
            <InputField
              label="Date"
              id={`airticket.flight_details[${index}].date`}
              type="text"
              register={register}
              placeholder={"01JAN"}
              name={`airticket.flight_details[${index}].date`}
              rules={{ required: "Date is required" }}
              errorMessage={
                errors?.airticket?.flight_details?.[index]?.date?.message
              }
              onChange={() =>
                clearErrors(`airticket.flight_details[${index}].date`)
              }
              bgAllDark={true}
            />
            <InputField
              label="Flight Number"
              id={`airticket.flight_details[${index}].flight_no`}
              type="text"
              placeholder="123"
              register={register}
              name={`airticket.flight_details[${index}].flight_no`}
              rules={{ required: "Flight number is required" }}
              errorMessage={
                errors?.airticket?.flight_details?.[index]?.flight_no?.message
              }
              onChange={() =>
                clearErrors(`airticket.flight_details[${index}].flight_no`)
              }
              bgAllDark={true}
            />
            <InputField
              label="Departure Time"
              id={`airticket.flight_details[${index}].dep_time`}
              type="text"
              register={register}
              placeholder="2:30 AM"
              name={`airticket.flight_details[${index}].dep_time`}
              rules={{ required: "Departure time is required" }}
              errorMessage={
                errors?.airticket?.flight_details?.[index]?.dep_time?.message
              }
              onChange={() =>
                clearErrors(`airticket.flight_details[${index}].dep_time`)
              }
              bgAllDark={true}
            />
            <InputField
              label="Arrival Time"
              id={`airticket.flight_details[${index}].arr_time`}
              type="text"
              register={register}
              placeholder="6:30 AM"
              name={`airticket.flight_details[${index}].arr_time`}
              rules={{ required: "Arrival time is required" }}
              errorMessage={
                errors?.airticket?.flight_details?.[index]?.arr_time?.message
              }
              onChange={() =>
                clearErrors(`airticket.flight_details[${index}].arr_time`)
              }
              bgAllDark={true}
            />
            {flightFields.length > 1 && (
              <button
                type="button"
                onClick={() => removeFlight(index)}
                className="relative -top-0.5 rounded-md border-red-500 bg-white py-2 text-red-500 hover:bg-red-500 hover:text-white"
              >
                Remove
              </button>
            )}
          </div>
        ))}

        <button
          type="button"
          onClick={() =>
            appendFlight({
              airline: "",
              from: "",
              to: "",
              date: "",
              flight_no: "",
              dep_time: "",
              arr_time: "",
            })
          }
          className="mt-2 text-blue-600 hover:text-blue-800"
        >
          Add Flight
        </button>
      </div>
      <div className="my-5">
        <Calculation
          supplierData={supplierData}
          register={register}
          errors={errors}
          clearErrors={clearErrors}
          watch={watch}
          setValue={setValue}
          control={control}
          getValues={getValues}
          AirTickettoSupplier={true}
          AirTicketfromPax={true}
          airTicket={true}
          updateData={updateData}
        />
      </div>
    </section>
  );
};

export default AirTicket;
